import RandingStyle32 from "../../randing/RandingStyle32";

function Randing535({ urlCode, urlCodeSettingId }) {
  return (
    <RandingStyle32
      urlCode={urlCode}
      urlCodeSettingId={urlCodeSettingId}
      imageFolderPath={`${process.env.REACT_APP_CDN_BASE}/images/504`}
      postBTN={`${process.env.REACT_APP_CDN_BASE}/images/389/03.gif`}
      companyName="본원"
      privacyCompanyName="청춘플란트치과의원"
      themeColor="#009493"
      mobileBottomBgColor="#0078ff"
      mobileContentPadding="54vw 10px 0"
      areaQuestion="현재 거주하시는 지역을 선택해주세요."
      areaOptions={[
        { label: "춘천", value: "춘천" },
        { label: "양구", value: "양구" },
        { label: "인제", value: "인제" },
        { label: "화천", value: "화천" },
      ]}
      // serviceInfoText="본 서비스는 당사와 제휴된 전국 30여개 병,의원에서 제공되며, 상담 신청 정보를 기반으로 적합한 제휴 병,의원을 안내해드립니다."
      imageAltTexts={{ header: "춘천 임플란트 혜택", sub: "설문 참여 이미지" }}
    />
  );
}

export default Randing535;
